/**
 * Opções de serialização do CSV exportado pelo DataGrid.
 *
 * Vive fora de `dataGridUtils.tsx` por não depender de nada de UI, o que permite reuso
 * em código testável sem carregar o Material-UI.
 */
export const csvOptionsValues = {
  delimiter: ';',
  utf8WithBom: true,
};
